import { Chakra } from "@airhelp/react-ui-components";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import type { CompensationFeeCardProps } from "./CompensationFeeCard.d";
import { CompensationFeeCardContent } from "../CompensationFeeCardContent/CompensationFeeCardContent";
import { compensationFeeCardHeaderStyles } from "./CompensationFeeCard.styles";

const { Box, VStack, Divider, useBreakpointValue } = Chakra;

export const CompensationFeeCard = ({
  heading,
  title,
  receiveValue,
  feeValue,
  footnote,
  progressValue,
  divider = false,
  variant = "basic",
}: CompensationFeeCardProps) => {
  const orientation = useBreakpointValue({ base: "horizontal", lg: "vertical" }) as "horizontal" | "vertical";
  const cardBackground = variant === "basic" ? "none" : "primary.100";
  return (
    <>
      <VStack
        pt={4}
        pb={9}
        justifyContent="space-between"
        px={{ base: 4, md: 8, lg: 4, xl: 8 }}
        align="stretch"
        bg={cardBackground}
        flex={1}
      >
        <Box maxW={{ lg: "450px" }}>
          <RichtextAdapter content={heading} customStyles={compensationFeeCardHeaderStyles} />
        </Box>
        <CompensationFeeCardContent
          title={title}
          receiveValue={receiveValue}
          feeValue={feeValue}
          footnote={footnote}
          progressValue={progressValue}
          variant={variant}
        />
      </VStack>
      {divider && <Divider color="greyscale.400" orientation={orientation} />}
    </>
  );
};
